import { enUS, ru, uk } from "date-fns/locale";
import { useContext, useState } from "react";
import { DateRangePicker } from "react-date-range";
import {
  defaultInputRanges,
  defaultStaticRanges,
} from "react-date-range/dist/defaultRanges";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { ContextProvider } from "../../contextProvider";
import "./DateRangePicker.css";

interface DateRange {
  startDate: Date;
  endDate: Date;
  key: string;
}

interface DateRangePickerProps {
  onDateChange: (ranges: any) => void;
  initialRange?: DateRange;
}

const setStartOfDayUTC = (date: Date) => {
  const d = new Date(date);

  d.setHours(0, 0, 0, 0);

  return d;
};

const setEndOfDayUTC = (date: Date) => {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
};

const DateRabgePicker = ({
  onDateChange,
  initialRange,
}: DateRangePickerProps) => {
  const { userData } = useContext(ContextProvider);
  const [range, setRange] = useState<DateRange>({
    startDate: setStartOfDayUTC(initialRange?.startDate || new Date()),
    endDate: setEndOfDayUTC(initialRange?.endDate || new Date()),
    key: "selection",
  });
  const handleSelect = (ranges: { selection: DateRange }) => {
    const updatedRange = {
      ...ranges.selection,
      startDate: setStartOfDayUTC(ranges.selection.startDate),
      endDate: setEndOfDayUTC(ranges.selection.endDate),
    };

    setRange(updatedRange);
    onDateChange(updatedRange);
  };

  const dateLocalization = {
    uk: uk,
    ru: ru,
    en: enUS,
  };

  const staticRangesLabels = {
    Today: "Today",
    Yesterday: "Yesterday",
    "This Week": "This Week",
    "Last Week": "Last Week",
    "This Month": "This Month",
    "Last Month": "Last Month",
  };

  const inputRangesLabels = {
    "days up to today": "days up to today",
    "days starting today": "days starting today",
  };

  const lacleRanges = defaultStaticRanges.map((item: any) => ({
    ...item,
    //@ts-expect-error
    label: staticRangesLabels[item.label],
  }));
  const lacleInputRanges = defaultInputRanges.map((item: any) => ({
    ...item,
    //@ts-expect-error
    label: inputRangesLabels[item.label],
  }));

  return (
    <DateRangePicker
      onChange={(item: { selection: DateRange }) => {
        handleSelect(item);
      }}
      showSelectionPreview={true}
      moveRangeOnFirstSelection={false}
      staticRanges={window.innerWidth > 768 ? lacleRanges : []}
      inputRanges={window.innerWidth > 768 ? lacleInputRanges : []}
      months={2}
      ranges={[range]}
      direction={window.innerWidth > 768 ? "horizontal" : "vertical"}
      preventSnapRefocus={true}
      calendarFocus="backwards"
      //@ts-expect-error
      locale={dateLocalization[userData!.selectedLanguage]}
    />
  );
};

export default DateRabgePicker;
